const CERTIFICATE_PATH_BY_SLUG: Record<string, string> = {
  "artificial-intelligence-bootcamp": "InaraX AI for Engineers Certificate",
  "data-analytics-bootcamp": "InaraX Data Analytics Professional Certificate",
  "ai-automation-bootcamp": "InaraX AI Automation Professional Certificate",
  "agentic-ai-bootcamp": "InaraX AI for Professionals Certificate",
  "ai-essentials": "InaraX AI Essentials Certificate",
  "agentic-ai": "InaraX Agentic AI Certificate",
};

export function getCertificatePathLabel(slug: string, courseTitle: string) {
  const fromSlug = CERTIFICATE_PATH_BY_SLUG[slug];
  if (fromSlug) return fromSlug;
  const trimmed = courseTitle.replace(/\s*bootcamp\s*$/i, "").trim();
  if (trimmed) return `InaraX ${trimmed} Professional Certificate`;
  return "InaraX Professional Certificate";
}

export function formatCompactCount(n: number) {
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1).replace(/\.0$/, "")}M`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(1).replace(/\.0$/, "")}k`;
  return n.toLocaleString("en-US");
}

const HERO_HIGHLIGHTS_BY_SLUG: Record<string, string[]> = {
  "artificial-intelligence-bootcamp": [
    "Comprehensive core topics",
    "Guided learning path and checkpoints",
    "Applied exercises and case studies",
  ],
  "data-analytics-bootcamp": [
    "Data analysis fundamentals",
    "Dashboarding and reporting",
    "Analytical writing and communication",
  ],
  "ai-automation-bootcamp": [
    "No-code workflow automation",
    "Step-by-step tool walkthroughs",
    "Real business use cases",
  ],
  "agentic-ai-bootcamp": [
    "Build multi-agent systems",
    "APIs, agents, and deployment",
    "End-to-end implementation practice",
  ],
  "agentic-ai": [
    "Build multi-agent systems",
    "APIs, agents, and deployment",
    "End-to-end implementation practice",
  ],
  "ai-essentials": [
    "No technical background needed",
    "Core AI concepts and prompting",
    "From everyday use to team adoption",
  ],
};

function defaultHeroHighlights() {
  return ["Structured curriculum", "Skills-focused modules", "Clear learning outcomes"];
}

export function getHeroHighlights(slug: string, title: string) {
  const fromSlug = HERO_HIGHLIGHTS_BY_SLUG[slug];
  if (fromSlug?.length) return fromSlug;

  const t = title.toLowerCase();
  if (t.includes("data analytics") || t.includes("analytics")) {
    return HERO_HIGHLIGHTS_BY_SLUG["data-analytics-bootcamp"] ?? defaultHeroHighlights();
  }
  if (t.includes("automation")) {
    return HERO_HIGHLIGHTS_BY_SLUG["ai-automation-bootcamp"] ?? defaultHeroHighlights();
  }
  if (t.includes("agentic") || t.includes("agent")) {
    return HERO_HIGHLIGHTS_BY_SLUG["agentic-ai-bootcamp"] ?? defaultHeroHighlights();
  }
  if (t.includes("artificial intelligence") || t.includes(" ai") || t.includes("machine learning")) {
    return HERO_HIGHLIGHTS_BY_SLUG["artificial-intelligence-bootcamp"] ?? defaultHeroHighlights();
  }

  return defaultHeroHighlights();
}

export function chunkTwoColumns(items: string[]) {
  const mid = Math.ceil(items.length / 2);
  return [items.slice(0, mid), items.slice(mid)];
}

function parseUsdPrice(priceText: string): number | null {
  const m = priceText.match(/\$\s*([0-9]+(?:[.,][0-9]+)?)/i);
  if (!m?.[1]) return null;
  const n = Number(m[1].replace(/,/g, ""));
  return Number.isFinite(n) ? n : null;
}

export function formatUsdUpperWhole(priceText: string) {
  const usd = parseUsdPrice(priceText);
  return typeof usd === "number" ? `$${Math.ceil(usd)}` : priceText;
}

